import { axios } from '~/plugins/axios'

export default {
  namespaced: true,
  actions: {
    async fetchTasks() {
      const response = await axios.get('/api/get-calling-tasks')
      return response.data
    },
    async uploadBase(_ctx, file) {
      const formData = new FormData()
      formData.append('file', file)
      const response = await axios.post('/api/calling-tasks/upload-base', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      return response.data
    },
    async createTask(_ctx, data) {
      const response = await axios.post('/api/calling-tasks/create', data)
      return response.data
    },
    async fetchTaskById(_ctx, taskId) {
      const response = await axios.get(`/api/calling-tasks/${taskId}`)
      return response.data
    },
    async updateTask(_ctx, { taskId, data }) {
      const response = await axios.post(`/api/update-calling-tasks/${taskId}`, data)
      return response.data
    },
    async fetchAgents() {
      const response = await axios.get('/api/target-ai/agents')
      return response.data
    },
    async fetchProjects() {
      const response = await axios.get('/api/target-ai/projects')
      return response.data
    },
    async startTask(_ctx, taskId) {
      const response = await axios.post(`/api/calling-tasks/${taskId}/start`)
      return response.data
    },
    async stopTask(_ctx, taskId) {
      const response = await axios.post(`/api/calling-tasks/${taskId}/stop`)
      return response.data
    },
    async pauseTask(_ctx, taskId) {
      const response = await axios.post(`/api/calling-tasks/${taskId}/pause`)
      return response.data
    },
  },
}
